import OrderableTypes from "../Orders/OrderableTypes.js";

/**
 * `CheckoutBasketItem`-like object collection
 *
 * @package HOPS
 * @subpackage Checkout
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class CheckoutBasketItemCollection {

	/**
	 * Constructor.
	 *
	 * @param {Array<Object>} `CheckoutBasketItem`-like objects
	 * @return {self}
	 */
	constructor(items) {

		/**
		 * `CheckoutBasketItem`-like objects
		 *
		 * @type {Array<Object>}
		 */
		this.items = items;

	}


	/**
	 * Map to an object indicating the VAT rates in the collection.
	 *
	 * @return {Object} VAT rate integer => array of items with that VAT rate
	 */
	getMappedByVatRate() {

		const vatRates = {};

		this.items.forEach(item => {
			const vatRate = item.VatRate;
			if (!vatRates[vatRate]) vatRates[vatRate] = [];
			vatRates[vatRate].push(item);
		});

		return vatRates;

	}


	/**
	 * Sort items for display by orderable type in the UI.
	 *
	 * @return {Array<Object>}
	 */
	getSortedByUiOrder() {
		return this.items.sort((a, b) => {
			if (b.OrderableType === OrderableTypes.Addon) return -1;
			else if (a.OrderableType === b.OrderableType) return 0;
			else return ((a.OrderableType > b.OrderableType) ? 1 : -1);
		});
	}

}

export default CheckoutBasketItemCollection;
